import "script-loader!slick-carousel"
import { debounce } from 'lodash'
import { isNarrowDevice } from "../sb/mediaQueries";

const $ = window.jQuery

const pageSlider = $('.slick-slider')
const teaserSliderSlide = $('.js-teaserSliderSlides')

const initPageSlider = () => {

  if (!pageSlider.length) {
    return
  }

  pageSlider.on('init', function (slick) {
    positionPageSliderNav()
  })

  pageSlider.slick({
    slidesToScroll: 1,
    rows: 0,
    autoplay: true,
    dots: true,
    dotsClass: 'slick-dots',
    arrows: true,
    waitForAnimate: false,
    prevArrow: '<button class="slick-prev"><svg><use xlink:href="/themes/custom/consor/dist/sprite.symbol.svg#chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next"><svg><use xlink:href="/themes/custom/consor/dist/sprite.symbol.svg#chevron-right"></use></svg></button>',
  })

  window.addEventListener('resize', debounce(() => {
    positionPageSliderNav()
  }, 250), false)
}

let isPageSliderNavPositioned = false
let pageSliderImg = null

const positionPageSliderNav = () => {

  if (!isPageSliderNavPositioned) {
    isPageSliderNavPositioned = true
    pageSlider.find('img').first().on('load', positionPageSliderNav)
    return
  }
  pageSlider.find('.slick-arrow').css('top', pageSlider.find('img').first().outerHeight() / 2)
  pageSlider.find('.slick-dots').css('top', pageSlider.find('img').first().outerHeight())
}

let teaserSliderInitialized = false
let teaserSliderMobile = false

const initTeaserSliders = () => {
  if (!teaserSliderSlide.length) {
    return
  }

  teaserSliderSlide.each(function (i, el) {
    let $el = $(el)
    let container = $el.closest('.js-teaserSlider')
    let navLinks = container.find('.js-teaserSliderNav li')

    if (!isNarrowDevice()) {
      if (teaserSliderMobile) {
        teaserSliderMobile = false
        container.find('.teaser-slide-image li').remove()
      }

      if (!teaserSliderInitialized) {
        let slider = $(el).slick({
          arrows: false,
          autoplay: true,
          dots: false,
          fade: true,
          rows: 0,
          slidesToScroll: 1,
          pauseOnHover: true,
          waitForAnimate: false,
        })
        slider
          .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            navLinks.eq(currentSlide).removeClass('is-active')
            navLinks.eq(nextSlide).addClass('is-active')
          })
        container.find('.js-teaserSliderNav li').on('mouseenter touchstart', function (e) {
          // TODO touch behavior
          slider.slick('slickPause').slick('slickGoTo', this.dataset.index)
        }).on('mouseleave', '.js-teaserSliderNav li', function (e) {
          slider.slick('slickPlay')
        }).on('click', '.js-teaserSliderNav li', function (e) {
          e.preventDefault()
          window.location = this.dataset.url
        })
        teaserSliderInitialized = true
      }

    }
    else {
      if (teaserSliderInitialized) {
        $(el).slick('unslick')
        teaserSliderInitialized = false
      }
      if (!teaserSliderMobile) {
        navLinks.each((j, link) => {
          $(link).clone().appendTo($el.find(`.teaser-slide-image[data-index=${j}]`))
        })
        teaserSliderMobile = true
      }
    }

  })
  window.addEventListener('resize', debounce(() => {
    initTeaserSliders()
  }, 250), false)
}

export const init = () => {
  initPageSlider()
  initTeaserSliders()


}



//////////////////
// WEBPACK FOOTER
// ./src/js/components/sliders.js
// module id = 16
// module chunks = 0